/**
 * お知らせJSON取得
 */
import logger from "./../../lib/logger";
import Repository from "./../JsonRepository";

const resource = "";

export default {
  /**
   * 緊急お知らせ取得
   */
  getEmergencyInfo() {
    let path = "info/emergency/kwb/emginfolist.json";
    logger.debug("json getEmergencyInfo(" + path + ")");
    return Repository.get(`${resource}` + path);
  },
  /**
   * 任意お知らせ取得
   */
  getAnyInfo() {
    let path = "info/optional/kwb/optinfolist.json";
    logger.debug("json getAnyInfo(" + path + ")");
    return Repository.get(`${resource}` + path);
  },
  /**
   * お知らせ情報取得
   */
  getInformationInfo() {
    let path = "info/info/infolist.json";
    logger.debug("json getInformationInfo(" + path + ")");
    return Repository.get(`${resource}` + path);
  },
  /**
   * 個別観測所・観測所詳細画面 お知らせ情報取得
   */
  getObsInformation(obsFcd) {
    let path = "info/obslist/obs/" + obsFcd + ".json";
    logger.debug("json getObsInformation(" + path + ")");
    return Repository.get(`${resource}` + path);
  },
  /**
   * CCTVカメラ・簡易カメラ画面 お知らせ情報取得
   */
  getScamInformation(scamId) {
    let path = "info/obslist/scam/" + scamId + ".json";
    logger.debug("json getScamInformation(" + path + ")");
    return Repository.get(`${resource}` + path);
  },
};
